import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { destroy, run } from '@api/v4/metadata_conversions';

const Row = ({
  id,
  metaTerm,
  keyTerm,
  convertToTags,
  setEditableKey,
  setShowForm,
  onRemove,
}) => {
  const [deleteMode, setDeleteMode] = useState(false);
  const [disableApply, setDisableApply] = useState(false);

  const edit = () => {
    setEditableKey(id);
    setShowForm(true);
  };

  const remove = async () => {
    await destroy(id);
    onRemove();
    Notify.create({ type: "success", title: "Conversion deleted" });
  };

  const runOnExistingFiles = async () => {
    setDisableApply(true);
    await run(id);
    Notify.create({ type: "success", title: "In Progress" });
  };

  const renderRow = () => (
    <li className="row limited-height">
      <span>{metaTerm}</span>
      <span>{convertToTags ? t("Tags") : `Custom Field: ${keyTerm}`}</span>
      <span>
        <button
          type="button"
          className="button secondary sm"
          onClick={runOnExistingFiles}
          disabled={disableApply}
        >
          <span className="bff-refresh" />
          {t('Apply')}
        </button>
      </span>
      <span className="button-container">
        <button
          type="button"
          onClick={edit}
        >
          <span className="bff-edit-asset" />
        </button>
        <button
          type="button"
          onClick={() => setDeleteMode(true)}
        >
          <span className="bff-trash" />
        </button>
      </span>
    </li>
  );

  const renderDeleteMode = () => (
    <div className="delete-mode">
      <span className="delete-text">{`${t('Are you sure you want to permanently delete')} ${metaTerm}?`}</span>
      <div className="delete-buttons">
        <button
          className="button tertiary md cancel"
          type="button"
          onClick={() => setDeleteMode(false)}
        >
          {t("Cancel")}
        </button>
        <button
          className="button warning md"
          type="button"
          onClick={remove}
        >
          {t("Delete Conversion")}
        </button>
      </div>
    </div>
  );

  return deleteMode ? renderDeleteMode() : renderRow();
};

Row.propTypes = {
  id: PropTypes.string.isRequired,
  metaTerm: PropTypes.string.isRequired,
  keyTerm: PropTypes.string,
  convertToTags: PropTypes.bool,
  onRemove: PropTypes.func,
  setEditableKey: PropTypes.func.isRequired,
  setShowForm: PropTypes.func.isRequired
};

Row.defaultProps = {
  keyTerm: null,
  createdAt: null,
  onRemove: () => {},
};

export default Row;
